import { useCallback, useState } from 'react';
import { FilterOperator } from '../../mql/operators';
import { FilterComponentProps } from '../components/FilterComponentProps';
import { FilterOperators } from '../components/FilterOperators';
import {
  isOperatorEmpty,
  resolveValueBasedOnBooleanOperator,
} from '../operatorUtils';
import { FilterItem, isFilterContextSimple } from '../types';

export const useOperators = ({
  filterItem,
  initialState,
  onChange,
  value,
}: {
  onChange?: FilterComponentProps['onOperatorChange']; // coming function should be always memoized and prevent rerender of node
  initialState?: FilterOperator;
  filterItem: FilterItem;
  value?: unknown;
}) => {
  const {
    column: { headerName, operators },
    filterContext,
  } = filterItem;

  const firstOperator = operators[0];

  if (firstOperator === undefined) {
    throw new Error(
      `Column '${headerName}' has no available filtering operators.`
    );
  }

  const defaultOperatorValue = isFilterContextSimple(filterContext)
    ? filterContext.operator
    : firstOperator;

  const [operator, setOperator] = useState<FilterOperator>(
    initialState ?? defaultOperatorValue
  );

  const memoizedNode = useCallback(
    () => (
      <FilterOperators
        headerName={headerName}
        operators={operators}
        operator={operator}
        onOperatorChange={o => {
          setOperator(o);
          onChange?.(o, resolveValueBasedOnBooleanOperator(o, value));
        }}
      />
    ),
    [headerName, onChange, operator, operators, value]
  );

  return {
    node: memoizedNode,
    operator,
    setOperator,
    emptyOperatorIsUsed: isOperatorEmpty(operator),
  };
};
